import React, { useState, useEffect } from 'react';
import Loading from './Loading';
import Tours from './Tours';
import TourData from './tourData'  //from https://course-api.com/react-tours-project
import './index.css';

// const url = 'https://course-api.netlify.app/api/react-tours-project'; sometimes the url API is down, so use this, so use './tourData'

function TourProject() {
  const [loading, setLoading] = useState(true);
  const [tours, setTours] = useState([]);

  const removeTour = (id) => {
    const newTours = tours.filter((tour) => tour.id !== id);
    setTours(newTours);
  };

  const fetchTours = async () => {
    setLoading(true);
    setLoading(false);
    setTours(TourData);
    // try {
    //   const response = await fetch(url);
    //   const tours = await response.json();
    //   setLoading(false);
    //   setTours(tours);
    // } catch (error) {
    //   setLoading(false);
    //   console.log(error);
    // }
  };
  useEffect(() => {
    fetchTours();
  }, []);
  if (loading) {
    return (
      <main>
        <Loading />
      </main>
    );
  }

  if (tours.length === 0) {
    return (
      <main>
        <div className="title">
          <h2>no tours left</h2>
          <button className="btn" onClick={() => fetchTours()}>
            refresh
          </button>
        </div> 
      </main>
    );
  }
  return (
    <main>
      <Tours tours={tours} removeTour={removeTour} />
    </main>
  );
}

export default TourProject;
